import React, { useState, useEffect, useRef } from "react";
import { BsPersonCircle } from "react-icons/bs";
import { FaAngleDown } from "react-icons/fa";
import { GoSignOut } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../components/Header/Header.css";

const Header = () => {
  const navigate = useNavigate();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const logout = () => {
    localStorage.removeItem("authData");
    toast.success("Logged out successfully");
    navigate("/");
  };

  return (
    <header className="admin-header">
      <h5 className="header-title">Welcome to Admin Panel !!</h5>

      <div className="profile-wrapper" ref={dropdownRef}>
        <div
          className="profile-btn"
          onClick={() => setDropdownVisible(!dropdownVisible)}
        >
          <BsPersonCircle size={26} />
          <span>Hello, Admin</span>
          <FaAngleDown
            className={`arrow ${dropdownVisible ? "rotate" : ""}`}
          />
        </div>

        {dropdownVisible && (
          <div className="profile-dropdown">
            <button onClick={logout}>
              <GoSignOut size={18} />
              <span>Sign Out</span>
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
